import React from 'react';
import {inject, observer} from 'mobx-react';
import {toJS} from 'mobx';
import WeaMenu from '../../../../../pc4public/portal/wea-menu/';

import E9LeftMenuTop4Email from './E9LeftMenuTop4Email';

@inject('portalThemeStore')
@observer
class E9LeftMenu extends React.Component {
    constructor(props) {
        super(props);
        this.onSelect = this.onSelect.bind(this);
        this.onModeChange = this.onModeChange.bind(this);
    }

    componentDidUpdate() {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLoadLeftMenuCount();
    }

    render() {
        const {portalThemeStore} = this.props;
        const {themeInfo, leftMenuObj, leftMenuMode} = portalThemeStore;

        const {themeData = {}} = themeInfo;
        const {styleConfig = {}} = themeData;
        const {leftmenu = {}} = styleConfig;
        const fontSize = parseInt(leftmenu.titleFontSize || '12px');

        const {leftMenu = [], leftMenuSelected = {}, leftMenuType} = leftMenuObj;
        let _leftMenu = toJS(leftMenu);
        let _leftMenuSelected = toJS(leftMenuSelected);
        let _selectedKey = _leftMenuSelected.id;

        return (
            <div className="e9aside-container">
                <WeaMenu
                    mode={leftMenuMode}
                    needSwitch={true}
                    inlineWidth={197}
                    verticalWidth={61}
                    fontSize={fontSize}
                    datas={(leftMenuType == 'email' && leftMenuMode == 'inline') ? _leftMenu.slice(2) : _leftMenu}
                    defaultSelectedKey={_selectedKey}
                    onSelect={this.onSelect}
                    onModeChange={this.onModeChange}
                    addonBefore={leftMenuType == 'email' ? <E9LeftMenuTop4Email emailMenu={_leftMenu} onSelect={this.onSelect}/> : ''}
                    addonBeforeHeight={leftMenuType == 'email' ? 40 : 0}
                />
            </div>
        );
    }

    onSelect(key, item, type) {
        window.isPortalRender = true;

        // type=0表示正常点击菜单，type=1表示点击菜单后面的图标
        const {portalThemeStore} = this.props;
        if (type == 1 && item.id == '536-53606') {  // 邮件菜单，清空垃圾箱
            portalThemeStore.onClearEmail(item);
        } else if (type == 0 && (item.id === '536-53611'||item.id === '536-53610')) { //我的文件夹、我的标签菜单 不跳转路由,只title跳转路由
            
        } else {
            if (type == 1) {
                item.url = item.titleUrl;
            }
            if(item.url != '') {
                if(item.url== '/spa/document/static/index.html#/main/document/add'
                    || item.url== '/spa/document/static/index.html#/main/document/search'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/add'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/queryFlowResult'
                    || item.url== '/spa/workflow/index_mobx.jsp#/main/workflow/supervise'){
                    item.url = item.url + "?menuidforportal=" + "left_" + item.infoId;
                }
                if(item.url && item.url.indexOf('tabTitle') < 0){
                    if(item.url && item.url.indexOf('#') != '-1'){
                        let urlArr = item.url.split('#');
                        if(urlArr[1] && urlArr[1].indexOf('?')!= '-1'){
                            item.url = item.url + "&tabTitle=" + item.name;
                        }else {
                            item.url = item.url + "?tabTitle=" + item.name;
                        }
                    }else if(item.url && item.url.indexOf('?') != '-1'){
                        item.url = item.url + "&tabTitle=" + item.name;
                    }else {
                        item.url = item.url + "?tabTitle=" + item.name;
                    }
                }

            }
            portalThemeStore.onLeftMenuSelectedChange(item);
            portalThemeStore.onLoadMain(item);
        }
    }

    onModeChange(leftMenuMode) {
        const {portalThemeStore} = this.props;
        portalThemeStore.onLeftMenuModeChange(leftMenuMode);
    }
}

export default E9LeftMenu;


// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/theme/ecology9/E9LeftMenu.js